/**
 * @namespace common
 */
var common = {
    /**
     * Configuration defaults (will be overridden by club configuration);
     */
    defaults: {
        globals: {},
        customKeys: [
            "NF",
            "100",
            "RF1"
        ],
        tagTimeout: 5,
        ageLimit: 13,
        ageLimitTanning: 18,
        timlineFuture: 2,
        timelinePast: 15,
        ticInterval: 3,
        alertTimeout: 60,
        scheduleLimit: 5,
        passcode: "",
        checkInDisplayOrder: "rtl",
        checkInRowCount: 1,
        checkInMemberCount: null,
        requireOperator: true,
        blackCardTypes: [
            "bc",
            "black",
            "bm",
            "hwbasc",
            "bnc",
            "blk",
            "a month can tan",
            "sf",
            "tn",
            "af",
            "b4n",
            "silver and fit",
            "silver sneakers bcm",
            "emp",
            "ledg",
            "12mo",
            "15ma",
            "prime",
            "20ss",
            "comp",
            "bfd",
            "crp",
            "19nr",
            "19co",
            "free",
            "active",
            "dmbike",
            "dmrow",
            "dmtred",
            "optumb",
            "fiton"
        ],
        operatorCardTypes: ["bcemp", "emp", "employee"],
        guestTimeLimit: 2,
        earlyActivation: 10,
        skinTypes: {
            "Type 1": {
                "name": "I - Sensitive",
                "desc": "Always burns, never tans (pale white; blond or red hair; blue eyes; freckles)."
            },
            "Type 2": {
                "name": "II - Fair",
                "desc": "Usually burns, tans minimally (white; fair; blond or red hair; blue, green, or hazel eyes)"
            },
            "Type 3": {
                "name": "III - Average",
                "desc": "Sometimes mild burn, tans uniformly (cream white; fair with any hair or eye color)"
            },
            "Type 4": {
                "name": "IV - Brown",
                "desc": "Burns, always tans well (moderate brown)"
            },
            "Type 5": {
                "name": "V - Dark Brown",
                "desc": "Very rarely burns, tans very easily (dark brown)"
            },
            "Type 6": {
                "name": "VI - Dark Brown",
                "desc": "Never burns, never tans (deeply pigmented dark brown to darkest brown)"
            }
        },
        tanningHistoryMonths: 36,
        skinTypeRestrictions : {
            "Type 1": 0,
            "Type 2": 1,
            "Type 3": 1,
            "Type 4": 1,
            "Type 5": 1,
            "Type 6": 1
        }
    },

    /**
     * Placeholder for configuration data returned from the socket 'config' event
     * @property {object}   customKeys              array of custom keys to be added to the onscreen keyboard for the member kiosk
     * @property {string}   clubCode                [placeholder] club code currently selected club code (all schedules will be made for this club)
     * @property {object}   amenities               [placeholder] array of amenities for kiosk scheduling
     * @property {number}   tagTimeout              passive tags will be removed after the timeout period (seconds)
     * @property {number}   ageLimit                default age limit required for a member to schedule any amenity
     * @property {number}   ageLimitTanning         default tanning limit required for a member scheduling any tanning amenity
     * @property {number}   timlineFuture           length of time the kiosk should display in hours
     * @property {number}   timelinePast            length of time in in the past to display on the admin kiosk in minutes
     * @property {number}   ticInterval             time interval for display on the top of the time line view in both kiosks
     * @property {number}   alertTimeout            length of time to display alerts on the admin kiosk before removing
     * @property {number}   scheduleLimit           members are limited to creating this many schedules within the timelineFuture time limit
     * @property {number}   guestTimeLimit          guest amenity activation time limit in minutes
     * @property {number}   earlyActivation         amount of time in minutes before an amenity can be activated from an admin kiosk
     * @property {string}   passcode                passcode required for amenity scheduling on the member kiosk
     * @property {string}   checkInDisplayOrder     determines which direction the check-in cards display. 'rtl' : right to left, 'ltr': left to right
     * @property {number}   checkInRowCount         determines how many check in rows to show on the admin kiosk
     * @property {?number}  checkInMemberCount      determines the maximum amount of member cards to display on the check-in window
     * @property {boolean}  requireOperator         determines if a member barcode is required to activate an amenity
     * @property {object}   blackCardTypes          array of member types that will be treated as black card members
     * @property {object}   operatorCardTypes       array of member types that will be treated as operators/employees
     * @property {object}   skinTypeRestrictions    object defining multipliers for each skin type to determine the maximum amount of time allowed for activation
     * @property {object}   skinTypes               object defining skin types and descriptions for display on the member kiosk
     */
    configData: {}, // placeholder for configuration data

    /** Socket host for websocket Connection
     * @member {?string}    url http://localhost
     */
    _SocketHost: null,

    /** Config host for club Connection
     * @member {?string}    url http://localhost
     */
    _ConfigHost: null,

    /** Socket path for websocket Connection
     * @member {?string}    path /
     */
    _SocketPath: null,

    /** Host URL for REST
     * @member {?string}    url http://localhost
     */
    _RestHost: null,

    /** Host URL for PROXY Connection
     * @member {?string}    url http://localhost
     */
    _ProxyHost: null,

    /** Host URL for Reports
     * @member {?string}    url http://localhost
     */
    _ReportHost: null,

    /** Host URL for Logging
     * @member {?string}    url http://localhost
     */
    _LogHost: null,

    /** Club Service URL
     * @member {?string}    url http://localhost
     */
    _ClubService: null,

    /**
     * default date format
     * @member {string}
     * @default
     */
    dateFormat: 'YYYY-MM-DDTHH:mm:ss.SSSSSZZ',

    /**
     * default time format
     * @member {string}
     * @default
     */
    timeFormat: 'hh:mm:ss',

    /**
     * Get current configured value from global, amenity, and club config
     * @param key           {string}    object key to return
     * @param amenityConfig {?object}   amenity config object to search if needed
     * @returns             {*|null}
     */
    getConfigValue: function (key, amenityConfig) {
        return common.configData.globals[key] || ((amenityConfig || {})[key]) || common.configData[key] || common.defaults[key] || null;
    },

    /**
     * Get url parameters
     * @member {function}
     * @method
     * @param   {string}        name    key name for the parameter
     * @param   {string}        url     url to parse
     * @returns {string|null}   value   value of desired key
     */
    getKioskIdFromUrl: function (name, url) {
        if (!url) url = location.href;
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regexS = "[\\?&]" + name + "=([^&#]*)";
        var regex = new RegExp(regexS);
        var results = regex.exec(url);
        return results === null ? null : results[1];
    },

        /**
     * Retrieves a parameter from the Url or returns null.
     * @param {*} parameterName Name of the parameter
     */
    getParameterFromUrl: function(parameterName) {
        var results = new RegExp(`[\?&]${parameterName}=([^&#]*)`).exec(window.location.href);
        if (results && results.length > 0) {
            return decodeURI(results[1]) || null;
        }
        return null;
    },

    /**
     * Display the loading dialog
     * @param {string}  message     dialog title
     * @param {number}  percentage  progressbar fill percentage (1-100)
     * @param {boolean} stack       true by default, aloows the loading dialog to appear over other dialogs
     */
    showLoader: function (message, percentage, stack) {
        var zIndex = Math.max.apply(null, Array.prototype.map.call(document.querySelectorAll('.modal'), function (el) {
            return +el.style.zIndex;
        })) + 10;

        message = message || pfFetchTranslation('loading');
        percentage = percentage || 100;
        if ($(this.loadingDialog).hasClass('in')) {
            return this.setLoader(message, percentage);
        } else if (!stack && $(".modal").hasClass("in")) {
            common.hideLoader();
            $(".modal").modal('hide');
        }

        this.loadingDialog = $('<div class="modal" id="pleaseWaitDialog" data-backdrop="static" data-keyboard="false" data-backdrop="static" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><div class="modal-logo"></div><h3 class="modal-title">' + message + '</h3></div><div class="modal-body"><div class="progress progress-striped active"><div class="progress-bar progress-bar-loading"  role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div></div></div></div></div></div>');
        $(".progress-bar", this.loadingDialog).width(percentage + '%').attr('aria-valuenow', percentage);

        if (stack) {
            $(this.loadingDialog).css('z-index', zIndex);
            setTimeout(function () {
                $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
            }, 0);
        }

        $(this.loadingDialog).modal();
    },

    /**
     * Display the loading dialog
     * @param {string}  message     dialog title
     * @param {number}  onConfirm  progressbar fill percentage (1-100)
     * @param {boolean} onDeny       true by default, aloows the loading dialog to appear over other dialogs
     */
    showConfirm: function (message, onConfirm, onDeny) {
        this.confirm = $('<div class="modal" id="confirmDialog" tabindex="-1" data-auto-hide="20000" data-backdrop="static" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><h3 class="modal-title">' + pfFetchTranslation('confirmationRequired') + '</h3></div><div class="modal-body">' + message + '</div><div class="modal-footer"><a class="btn denyBtn" data-dismiss="modal">' + pfFetchTranslation('no') + '</a><button class="btn btn-primary confirmBtn" data-dismiss="modal">' + pfFetchTranslation('yes') + '</button></div></div></div></div>');
        this.confirm.find('.confirmBtn').on('click', onConfirm);
        if (onDeny) this.confirm.find('.denyBtn').on('click', onDeny);
        this.confirm.on('hidden.bs.modal', function (e) {
            e.target.remove();
        });
        $(this.confirm).modal();
    },

    /**
     * Sets the loading dialog title and percentage
     * @param {string}  message     dialog title
     * @param {?number}  percentage  progressbar fill percentage (1-100)
     */
    setLoader: function (message, percentage) {
        message = message || pfFetchTranslation('loading');
        percentage = percentage || 100;
        $(this.loadingDialog).find(".modal-title").empty().html(message);
        $(this.loadingDialog).find(".progress-bar").width(percentage + '%').attr('aria-valuenow', percentage);
    },

    /**
     * Hides the existing loading dialog
     */
    hideLoader: function () {
        $(this.loadingDialog).modal('hide');
        $(this.loadingDialog).remove();
    },

    /**
     * Display Error dialog
     * @param {?object}  jqXHR       xhr data
     * @param {?object}  textStatus  status
     * @param {?object}  errorThrown error
     * @param {?object}  title       dialog title
     * @param {?boolean} timeout     close dialog in 30 sec?
     * @param {?boolean} dismissible close button enabled?
     * @param {?boolean} stack       stack defaults to true
     */
    showError: function (jqXHR, textStatus, errorThrown, title, timeout, dismissible, stack, errorClass) {
        var dismiss = '';
        var status = '';

        errorClass = errorClass || 'error';
        dismissible = dismissible !== false;
        // unauthorized
        if (jqXHR && jqXHR.status === 401) {
            dismissible = false;
            errorThrown = pfFetchTranslation('kioskUnauthorized');
            status = ' unauthorized';
        }

        $('#confirmSchedule').button('reset');
        $("#roomSchedules").removeClass('empty').addClass('emptyActive');

        common.hideLoader();

        var modalTitle = title || pfFetchTranslation('weAreSorry');

        if (dismissible) {
            dismiss = '<div class="modal-footer"><button id="confirmError" type="submit" class="btn btn-primary" data-dismiss="modal">' + pfFetchTranslation('ok') + '</button></div>';
        }

        if ($(".modal-body", '.' + errorClass).html() === errorThrown && $('#errorDialog').hasClass('in')) {
            return;
        }

        var errorDialog = $('<div class="modal' + status + ' ' + errorClass + '" id="errorDialog" tabindex="-1" data-backdrop="static" role="dialog" aria-labelledby="errorDialogLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><form id="errorForm" class="form" role="form" onsubmit="return false"><div class="modal-header"><div class="modal-logo"></div><h3 class="modal-title">' + modalTitle + '</h3></div><div class="modal-body"></div>' + dismiss + '</form></div></div></div>');

        $(".modal-body", errorDialog).empty().html(errorThrown);

        if (stack === false) {
            $("*").modal('hide');
        }

        $(errorDialog).modal();

        if (timeout)
            setTimeout(function () {
                $(errorClass).modal('hide');
            }, 30000);

        $(errorDialog).on('hidden.bs.modal', function () {
            $(this).remove();
        });
    },

    /**
     * Get the amenity type for an amenity equipment
     * @param {string} amenityEquipmentGuid
     * @returns {object} equipment
     */
    getAmenityType: function (amenityEquipmentGuid) {
        var amenities = common.configData.amenities;
        for (var a = 0; a < amenities.length; a++) {
            var amenity = amenities[a];
            for (var i = 0; i < amenity.equipment.length; i++) {
                var equip = amenity.equipment[i];
                if (equip.id === amenityEquipmentGuid) {
                    equip.pepf = amenity.pepf;
                    equip.categoryName = amenity.categoryName;
                    equip.amenityName = amenity.name;
                    equip.categoryId = amenity.categoryId;
                    equip.waiver = amenity.waiver;
                    equip.activation = amenity.activation;
                    return equip;
                }
            }
        }
    },

    /**
     * Get the amenity type for an amenity equipment
     * @param   {string}        amenityEquipmentGuid
     * @param   {string|number} startTime
     * @returns {object}        activity
     */
    getTrainingName: function (amenityEquipmentGuid, startTime) {
        var equip = common.getAmenityType(amenityEquipmentGuid);
        var startDay = moment(startTime).format('dddd');
        var schedule;
        if (equip.pepf === "") {
            return false;
        } else {
            var schedules = equip.pepf[startDay];
            for (var i = 0; i < schedules.length; i++) {
                schedule = schedules[i];
                if (moment(schedule.startTime, 'h:mma').format('h:mma') == moment(startTime).format('h:mma')) {
                    return schedule.activity;
                }
            }
        }
    },

    convertByteToHex: function (byte) {
        return String.fromCharCode(parseInt(byte, 16));
    },

    /**
     * Parses time in milliseconds to time structure
     * @param {Number} ms as milliseconds
     * @returns {Object} timeStruct
     * @return  {Integer} timeStruct.d days
     * @return  {Integer} timeStruct.h hours
     * @return  {Integer} timeStruct.m minutes
     * @return  {Integer} timeStruct.s seconds
     *
     * See: https://stackoverflow.com/questions/9763441/milliseconds-to-time-in-javascript
     */
    millisecToTimeStruct: function (ms) {
        // ~~ is the equivalent of Math.trunc
        var d, h, m, s;
        if (isNaN(ms)) {
            return {};
        }
        d = ms / (1000 * 60 * 60 * 24);
        h = (d - ~~d) * 24;
        m = (h - ~~h) * 60;
        s = (m - ~~m) * 60;
        return {d: ~~d, h: ~~h, m: ~~m, s: ~~s};
    },

    /**
     * pad a number left
     * @param   {number}  num
     * @param   {number}  padding
     * @returns {string}
     */
    padNumberLeft: function (num, padding) {
        if (num.toString().length <= padding) {
            return new Array(padding - num.toString().length + 1).join('0') + num;
        }
        return num;
    },

    /**
     * convert dot separated tagId to barcode
     * @param   {string}  tagId 12 byte tagId (i.e. 00.00.00.00.00.00.00.00.00.00.00.00)
     * @returns {string}
     */
    convertTagtoBarcode: function (tagId) {
        var tagArr, barcode;
        if (tagId.indexOf('.') === -1) {
            return tagId;
        } else {
            tagArr = tagId.split('.');
            barcode = '';

            if (convertByteToHex(tagArr[0]) === 'R' && convertByteToHex(tagArr[1]) === 'F') {
                var num, length = parseInt(tagArr[3], 16);
                barcode += 'RF';
                barcode += tagArr[2];
                num = parseInt(tagArr[4] + tagArr[5] + tagArr[6] + tagArr[7] + tagArr[8] + tagArr[9] + tagArr[10] + tagArr[11], 16);
                barcode += padNumberLeft(num, length);
            } else if (convertByteToHex(tagArr[6]) === 'R' && convertByteToHex(tagArr[7]) === 'F') {
                barcode += 'RF' + convertByteToHex(tagArr[8]);
                barcode += padNumberLeft(parseInt(tagArr[9] + tagArr[10] + tagArr[11], 16), 7);
            }

            return barcode;
        }
    },

    /**
     * Checks the provided url for mixed content error
     * @param url
     * @param callback
     * @returns {*}
     */
    checkMixedContent: function (url, callback) {
        var protocol = url.split('//')[0];
        if (protocol !== window.location.protocol) {
            if (callback) {
                callback();
            } else {
                return common.showError(null, null, pfFetchTranslation('mixedContent', [window.location.protocol, protocol]), null, null, true);
            }
        }
    },

    /**
     * formats minutes to a human readable 'X hours X minutes' string
     * @param {number} min  minutes to format
     * @returns {string}
     */
    formatMinutes: function (min) {
        var hour = pfFetchTranslation('dateTime.hour');
        var minute = pfFetchTranslation('dateTime.minute');

        var duration = '';
        var h = parseInt(min / 60) % 60;
        var m = min % 60;
        if (h > 0) {
            duration += h + ' ' + hour + (h > 1 ? 's' : '');
        }
        if (m > 0) {
            if (h > 0) {
                duration += ' & ';
            }
            duration += m + ' ' + minute + (m > 1 ? 's' : '');
        }
        return duration;
    },

    /**
     * checks a membertype to see if it contains any value in the provided array
     * @param {string} memberType   the member type to check against
     * @param {object} typesList    array of string values to validate
     * @returns {boolean}
     */
    isValidMemberType: function (memberType, typesList) {
        if (!memberType) {
            return false;
        }
        return new RegExp(typesList.map(function (t) {
            return t.toLowerCase();
        }).join("|")).test(memberType.toLowerCase());
    },

    isArray: function (value) {
        return value && typeof value === 'object' && value.constructor === Array;
    },

    isFunction: function (func) {
        return (typeof func === 'function');
    },

    isUndefined: function (obj) {
        return (typeof obj === 'undefined');
    },

    isNull: function (value) {
        if (!value) {
            return true;
        }
        return false;
    },

    isEmpty: function (value) {
        if (typeof value === 'string' || value instanceof String) {
            return value.length === 0;
        }

        if (this.isArray(value)) {
            return value.length === 0;
        }

        return this.isNull(value);
    },

    /**
     * determines if a string is a valid Guid.
     * @param {string} str   the member type to check against
     * @returns {boolean}
     */
    isValidGuid: function (str) {
        if (str) {
            var pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
            return pattern.test(str);
        }
        return false;
    },

    setMomentOffset: function (serverTime) {
        var offset = new Date(serverTime).getTime() - Date.now();
        moment.now = function () {
            return offset + Date.now();
        };
    },

    getEnvironment: function () {
        var env;
        var match = window.location.hostname.match(/(pfmk)-?([^.]*)./);
        if (match) {
            env = match[2] === '' ? 'production' : match[2];
        } else {
            env = 'local';
        }
        return env;
    },

    generateWaiverList: function (waiverSignings) {
        var waivers = {};
        for (var i = 0; i < waiverSignings.length; i++) {
            var w = waiverSignings[i];
            if (!waivers.hasOwnProperty(w.waiverTitle)) {
                waivers[w.waiverTitle] = {
                    signings: [w]
                };
            } else {
                waivers[w.waiverTitle].signings.push(w);
            }
        }
        return waivers;
    },

    removeEmptyProps: function (obj) {
        Object.keys(obj).forEach(function (key) {
            if (obj[key] && typeof obj[key] === 'object')
                removeEmpty(obj[key]);
            else if (obj[key] == null)
                delete obj[key];
        });
        return obj;
    },

    getNestedObject: function getNestedObject(nestedObj, pathArr) {
        return pathArr.reduce(function (obj, key) {
            return obj && obj[key] !== 'undefined' ? obj[key] : undefined;
        }, nestedObj);
    },

    getMaxAmenityDuration: function(){
        return common.configData.amenities.reduce(function(a,c){
            return Math.max(a,+c.interval);
        },0);
    },
    /**
     * dom element animation function
     * @param {(string|Element)} selector id or class of element being animated
     *
     * @param {object} opts  animation config object
     * @param {string} opts.attribute  style attribute to animate
     * @param {number} [opts.start]  starting position of attribute, null will default to the current attribute position
     * @param {number} opts.end  ending position of attribute
     * @param {number} [opts.duration=250]  duration of animation in milliseconds
     *
     * @param {function} [fn]  callback function after animation has stopped
     */
    animateFn:function animate(selector, opts, fn){
        var stop = false;
        var $el = typeof selector == "string" ? document.querySelector(selector) : selector;

        var elCur = +$el.style[opts.attribute].replace('px', '');
        var elStart = opts.start || elCur;
        var elDest = elCur + (opts.end);
        var duration = opts.duration || 250;
        var start = null;
        var end = null;
        var x;
        function startAnim(timeStamp) {
            start = timeStamp;
            end = start + duration;
            draw(timeStamp);
        }

        function draw(now) {
            var p, offsetPx;
            if (stop){
                typeof fn == "function" && fn($el);
                return;
            }
            if (now - start >= duration) stop = true;
            p = (now - start) / duration;
            x = elStart + (elDest - elStart) * p;
            offsetPx = opts.end > 0 ? Math.min(x,elDest) : Math.max(x,elDest);
            $el.style[opts.attribute] = offsetPx + "px";
            requestAnimationFrame(draw);
        }
        requestAnimationFrame(startAnim);
    },

    Member: function (memberData, includeWaivers) {
        this.active = (memberData.Active === true) || (memberData.active === true);
        this.agreementNumber = memberData.AgreementNumber || memberData.agreementNumber;
        this.birthDate = memberData.BirthDate || memberData.birthDate;
        this.cellPhoneProvider = memberData.CellPhoneProvider || memberData.cellPhoneProvider;
        this.city = memberData.City || memberData.city;
        this.clubCode = memberData.HomeClub || memberData.ClubCode || memberData.clubCode;
        this.countryCode = memberData.CountryCode || memberData.countryCode;
        this.email = memberData.Email || memberData.email;
        this.firstName = memberData.FirstName || memberData.firstName;
        this.gender = memberData.Gender || memberData.gender;
        this.guid = memberData.MemberGuid || memberData.Guid || memberData.guid;
        this.hasSuitableCredit = memberData.HasSuitableCredit || memberData.hasSuitableCredit;
        this.inGoodStanding = memberData.InGoodStanding || memberData.inGoodStanding;
        this.lastName = memberData.LastName || memberData.lastName;
        this.lastUpdate = memberData.LastUpdate || memberData.lastUpdate;
        this.memberBarcode = memberData.Barcode || memberData.MemberBarcode || memberData.memberBarcode;
        this.memberType = memberData.MemberType || memberData.memberType;
        this.phoneNumber = memberData.PhoneNumber || memberData.phoneNumber;
        this.postalCode = memberData.PostalCode || memberData.postalCode;
        this.stateCode = memberData.StateCode || memberData.stateCode;
        this.status = memberData.Status || memberData.status;
        this.tag = memberData.Tag || memberData.tag;
        if (includeWaivers !== false) {
            this.signedWaivers = memberData.SignedWaivers || memberData.signedWaivers;
        }
    },

    Waiver: function (waiverData) {
        this.waiverId = waiverData.WaiverId || waiverData.waiverId;
        this.content = waiverData.Content || waiverData.content;
        this.memberGuid = waiverData.MemberGuid || waiverData.memberId;
        this.title = waiverData.Title || waiverData.title || waiverData.waiverTitle || waiverData.WaiverTitle;
        this.signDate = waiverData.SignDate || waiverData.signDate;
        this.url = waiverData.URL || waiverData.url;
    },
    resolveBarcode: function (memberBarcode) {
        //console.group('resolve barcode');
        //console.log('memberBarcode: ' + memberBarcode);
        var sbc = memberBarcode
            .replace(/[^0-9a-z.\-/]/gi, '')
            .replace('/', '|')
            .replace('||', '|')
            .split('|');
        //console.log('split: ' + JSON.stringify(sbc));

        var barcode = sbc[0] && sbc[0].replace(/[^0-9a-z.\-/]/gi, '');
        var channel = sbc[1] && sbc[1].replace(/[^0-9a-z.-]/gi, '');
        var source = (typeof pfKioskAdmin === 'object') ? 'admin' : 'member';
        //console.log('barcode: ' + barcode);
        //console.log('channel: ' + channel);
        //console.groupEnd();
        return {barcode:barcode, channel:channel, source:source};
    },
    isMacAddress: function (string){
        var regExTest = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;
        return regExTest.test(string)
    }
};

if (typeof module === 'object' && module.exports) {
    module.exports = common;
}
